import styled from 'styled-components';
import { useState, useId } from 'react';
import { motion } from 'framer-motion';
import resume from '../../assets/resume_Parth Hingu.pdf';
import { ReactComponent as DownloadIcon } from '../../assets/download.svg';
import DarkModeToggle from '../DarkMode/DarkModeToggle';

const Header = ({ sortHandler }) => {
  const [hoveredNavItem, setHoveredNavItem] = useState('all');

  const OPTIONS = ['all', 'about', 'projects', 'media'];
  const id = useId();

  const hoverHandler = (option) => {
    setHoveredNavItem(option);
    sortHandler(option);
  };

  return (
    <HeaderWrapper>
      <SideBarLeft>
        <DarkModeToggle />
      </SideBarLeft>
      <nav>
        <Wrapper>
          {OPTIONS.map((option, index) => (
            <ListWrapper
              key={index}
              style={{
                '--zIndex': hoveredNavItem === option ? 1 : 2,
              }}
            >
              {hoveredNavItem === option && (
                <BackgroundHover
                  as={motion.div}
                  initial={false}
                  layoutId={id}
                  animate={{
                    borderRadius: 24,
                  }}
                />
              )}
              <Option onClick={() => hoverHandler(option)}>{option}</Option>
            </ListWrapper>
          ))}
        </Wrapper>
      </nav>
      <SideBarRight>
        <Link
          as={motion.a}
          whileHover={{ scale: 1.1 }}
          href={resume}
          target='_blank'
          rel='noreferrer'
        >
          <p>resume</p>
          <Icon />
        </Link>
      </SideBarRight>
    </HeaderWrapper>
  );
};

export default Header;

const Wrapper = styled.div`
  background-color: hsla(0, 0%, 0%, 0.1);
  width: fit-content;
  margin: auto;
  padding: 8px 8px;
  border-radius: 50px;
  display: flex;
  gap: 16px;
  list-style-type: none;

  @media (max-width: 500px) {
    padding: 6px 6px;
  }
`;

const ListWrapper = styled.li`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: var(--zIndex);
`;

const BackgroundHover = styled.div`
  background-color: ${({ theme }) => theme.tileBackground};
  inset: 0;
  position: absolute;
`;

const Option = styled.a`
  position: relative;
  padding: 4px 8px;
  cursor: pointer;
  text-transform: capitalize;
  font-size: 0.875rem;
  &:hover {
    opacity: 0.5;
  }
  @media (max-width: 500px) {
    padding: 4px 8px;
  }
`;

const SideBar = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-around;
  align-items: center;
`;

const SideBarLeft = styled(SideBar)`
  justify-content: flex-start;
  padding-left: 16px;
  @media (max-width: 500px) {
    padding-left: 0px;
  }
`;

const SideBarRight = styled(SideBar)`
  justify-content: flex-end;
  padding-right: 16px;
  @media (max-width: 500px) {
    padding-right: 0px;
  }
`;

const HeaderWrapper = styled.header`
  display: flex;
  padding: 0 16px;
`;

const Link = styled.a`
  cursor: pointer;
  text-decoration: none;

  background: linear-gradient(
    156deg,
    rgba(0, 105, 193, 1) 11%,
    rgba(69, 204, 168, 1) 55%,
    rgba(203, 0, 60, 1) 100%
  );

  color: transparent;
  background-clip: text;

  &:hover {
    color: rgba(0, 105, 193, 1);
  }
  p {
    font-family: 'Bashing';
    font-size: 2rem;
    font-weight: 400;
    @media (max-width: 500px) {
      display: none;
    }
  }
`;
const Icon = styled(DownloadIcon)`
  display: none;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.text};
  @media (max-width: 500px) {
    height: 24px;
    width: 24px;
    cursor: pointer;
    display: block;
  }
`;
